import type { PlotLayout } from "./layout/plot-layout";
import { type LegendParts, legendShowsAnything } from "./plan-panel-chrome";
import type { PreparedSeries } from "./prepare-series";
import { SeriesLabel } from "./series-label";

export function PanelLegend({
    series,
    layout,
    parts,
}: {
    series: PreparedSeries[];
    layout: PlotLayout;
    parts: LegendParts;
}) {
    if (series.length === 0 || !legendShowsAnything(parts)) return null;

    return (
        // px, not spacing tokens: --spacing is 0.24rem, so token sizes land on half pixels.
        <div
            className={"flex min-w-0 flex-wrap items-center justify-start gap-x-4 gap-y-[6px] pt-2"}
            style={{ marginLeft: layout.gutters.left, marginRight: layout.gutters.right }}
        >
            {series.map((s) => (
                <div key={String(s.streamId)} className={"flex min-w-0 items-center gap-1.5"}>
                    <span
                        aria-hidden
                        className={"inline-block h-[4px] w-[14px] shrink-0 rounded-full"}
                        style={{ backgroundColor: s.color }}
                    />
                    <div className={"truncate text-xs font-normal text-muted-foreground"}>
                        <SeriesLabel
                            deviceName={parts.devices ? s.name : null}
                            sensorClusterName={parts.sensorClusters ? s.sensorClusterName : null}
                            sensorElementName={parts.sensorElements ? s.sensorElementName : null}
                            showUnitCategory={parts.categories}
                            unitCategory={s.unitCategory}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
